var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand"},[_c('h1',{staticClass:"m-0"},[_c('router-link',{attrs:{"to":"/"}},[_c('c-image',{attrs:{"src":require('@/assets/images/rp-logo-white.png'),"alt":"Neon","width":32,"height":32}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }